import Column from '../../../../../components/Column/Column';
import Columns from '../../../../../components/Columns/Columns';
import RichText from '../../../../../components/RichText/RichText';
import Stack from '../../../../../components/Stack/Stack';
import Title from '../../../../../components/Title/Title';
import useTrans from '../../../../../hooks/ui/useTrans';
import NoContentMessage from '../../../../../tenant-dashboard/components/NoContentMessage/NoContentMessage';
import determineCompatibilityForSingleOrMultiDay from '../../../../helpers/determineCompatibilityForSingleOrMultiDay';
import BoatModelCategory from '../../../../types/BoatModelCategory';
import BoatModelWithMedia from '../../../../types/BoatModelWithMedia';
import BoatModelCard from '../BoatModelCard/BoatModelCard';

type BoatModelCardsOfCategoryProps = {
    boatModels: Array<BoatModelWithMedia>;
    category: BoatModelCategory | null;
    onSelect: (boatModel: BoatModelWithMedia, quantity: number) => void;
    onPreview: (boatModel: BoatModelWithMedia) => void;
    customerWantsMultipleDays: boolean | undefined;
};

const BoatModelCardsOfCategory = ({
    boatModels,
    category,
    onSelect,
    onPreview,
    customerWantsMultipleDays,
}: BoatModelCardsOfCategoryProps) => {
    const trans = useTrans(
        'CustomerArea.BookingForm.BoatModelCardsOfCategory.'
    );

    return (
        <Stack space="large">
            {category && (
                <Stack space="none">
                    <Title>{category.name}</Title>
                    {category.description && (
                        <RichText html={category.description} subdued />
                    )}
                </Stack>
            )}

            {boatModels.length === 0 ? (
                <NoContentMessage variant="subtle">
                    {trans('NoMatchingBoats')}
                </NoContentMessage>
            ) : (
                <Columns
                    gap="xlarge"
                    collapsedGap="xlarge"
                    collapseBelow="tablet"
                    wrap
                    animatePresence
                    align="stretch"
                >
                    {boatModels.map((boatModel) => {
                        const compatible =
                            determineCompatibilityForSingleOrMultiDay(
                                customerWantsMultipleDays,
                                boatModel.singleOrMultiDay
                            );

                        return (
                            <Column width="1/2" key={boatModel.id}>
                                <BoatModelCard
                                    boatModel={boatModel}
                                    onSelect={onSelect}
                                    onPreview={onPreview}
                                    incompatibleSingleOrMultiDay={!compatible}
                                />
                            </Column>
                        );
                    })}
                </Columns>
            )}
        </Stack>
    );
};

export default BoatModelCardsOfCategory;
